import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import Button from "../../components/forms/Button";
const CategoriaForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>
        <FormGroup>
          <label>Categoria</label>
          <Input type='text' {...register("categoria", {required: "Campo obligatorio"})}/>
          {errors.categoria && <p style={{color: 'red'}}>{errors.categoria?.message}</p>}
        </FormGroup>
      </Card>
      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default CategoriaForm;
